import { render } from "./headlineMedium.vue?vue&type=template&id=3d820b8a"
import script from "./headlineMedium.vue?vue&type=script&lang=js"
export * from "./headlineMedium.vue?vue&type=script&lang=js"

import "./headlineMedium.vue?vue&type=style&index=0&id=3d820b8a&lang=scss"

import exportComponent from "C:\\Users\\chbo\\Documents\\repos\\semco-maritime-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__